import Flickity from "flickity";

window.imageScroller = (autoplaySp) => {
    return {
        sliderContainer: null,
        slider: null,
        currentSlide: 0,
        sliderEnd: false,
        sliderFullWidth: 0,
        isSelected: null,
        tags: [],
        currentFilter: null,
        visible: false,
        isPaused: false,
        tickerSpeed: 0.8,
        sliderStarted: false,
        init() {
            this.initSlider(this.getSliderToActivate());

            if (this.sliderStarted) {
                pegasus.onResizeFinished(() => {
                    this.sliderResize();
                }, false);
            }

            this.eventListeners();
        },
        getSliderToActivate() {
            const currentOption = localStorage.getItem("selectedOption");
            let sliderToActivate = this.$refs.imageScroller;

            return sliderToActivate;
        },
        initSlider(slider) {
            this.sliderContainer = slider;

            const _this = this;

            let update = null;

            let defaults = {
                cellAlign: "left",
                contain: true,
                draggable: false,
                pageDots: false,
                prevNextButtons: false,
                imageLoaded: true,
                wrapAround: true,
                adaptiveHeight: false,
                freeScroll: true,
                on: {
                    ready: function () {
                        window.dispatchEvent(new Event("resize"));

                        _this.sliderResize(this);
                    },
                },
            };

            let options = {};

            if (typeof autoplaySp !== "undefined" && autoplaySp !== 0) {
                options["autoPlay"] = autoplaySp * 1000;
            }

            options = pegasus.extend(defaults, options);

            this.slider = new Flickity(this.sliderContainer, options);

            update = () => {
                this.slider.x =
                    (this.slider.x - this.tickerSpeed) %
                    this.slider.slideableWidth;
                this.slider.selectedIndex = this.slider.dragEndRestingSelect();
                this.slider.updateSelectedSlide();
                this.slider.settle(this.slider.x);
                window.requestAnimationFrame(update);
            };

            this.slider = new Flickity(this.sliderContainer, options);

            if (!this.sliderStarted) {
                setTimeout(() => {
                    update();
                }, 700);
            }
            this.sliderStarted = true;

            const slides = this.sliderContainer.querySelectorAll(".image");
            slides.forEach((slide) => {
                const image = slide.querySelector("img");
                if (image) {
                    image.style.maxHeight = "455px";
                    slide.style.display = "flex";
                    slide.style.alignItems = "center";
                }
            });

            this.sliderContainer.addEventListener("mouseenter", () => {
                this.tickerSpeed = 0;
            });

            this.sliderContainer.addEventListener("mouseleave", () => {
                this.tickerSpeed = 0.6;
            });
        },

        sliderResize(flickity) {
            const flickitySliders = document.querySelectorAll(
                ".Image__Scroller-slider .flickity-slider"
            );

            this.sliderFullWidth = 0;

            flickitySliders.forEach((slider) => {
                const slides = slider.querySelectorAll(
                    ".Image__Scroller-slider .image"
                );
                let height = 0;

                slides.forEach((slide) => {
                    slide.style.height = "";
                    this.sliderFullWidth += slide.offsetWidth;
                    if (slide.offsetHeight > height) {
                        height = slide.offsetHeight;
                    }
                });

                slides.forEach((slide) => {
                    slide.style.height = height + "px";
                });

                slider.style.height = "";
                slider.style.height = height + "px";
            });
        },

        eventListeners() {
            this.slider.on("change", (slide) => {
                this.currentSlide = slide;
            });
            this.slider.on("scroll", (e) => {
                this.sliderEnd = e.toFixed(2) >= 1;
            });
        },
    };
};
